import { PlatformIcon } from "@/components/PlatformBadge";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function SyncStatusStrip({ freshness }) {
  if (!freshness) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="sync-status-strip">
      {freshness.platforms.map((p) => {
        const ok = p.status === "connected";
        return (
          <span key={p.platform} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${ok ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-amber-200 bg-amber-50 text-amber-700"}`}>
            <PlatformIcon platform={p.platform} className="h-3.5 w-3.5" />
            {p.label}
            {ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <AlertTriangle className="h-3.5 w-3.5" />}
            {!ok && <span className="font-semibold">Needs reconnection</span>}
          </span>
        );
      })}
    </div>
  );
}
